import {all, takeEvery, call, put } from 'redux-saga/effects';

import ShopActionTypes from './shop.types';

import { firestore, convertCollectionsSnapshotToMap } from '../../firebase/firebase.utils';

import {fetchCollectionsSuccess, fetchCollectionsFailure} from './shop.actions'


export function* fetchCollectionsAsync() {

    try {
        const collectionRef = yield firestore.collection("collections");
			
        const snapshot = yield collectionRef.get();
		
	    const collectionsMap = yield call(convertCollectionsSnapshotToMap, snapshot);

		yield put(fetchCollectionsSuccess(collectionsMap));
			
    } catch (err) {
        put(fetchCollectionsFailure(err.message))
    }				

}

export function* fetchCollectionsStart() {
    yield takeEvery(ShopActionTypes.FETCH_COLLECTIONS_START, fetchCollectionsAsync);
}

export function* shopSagas() {
    yield all([call(fetchCollectionsStart)]);
}
 